import React from 'react';
import { Table } from 'semantic-ui-react';
import { firstErrorMessage } from '@/utils/errors';
import { states } from '@/constants/lifecycle';
import TableHeader from '@/components/table/TableHeader';
import UserGroupsTableColumns from '../containers/UserGroupsTableColumns';

const UserGroupsTableHeader = ({
  category,
  children,
  columns,
  items,
  onCheckBoxClick,
  readErrors,
  readStatus,
  showColumns,
}) => (
  <Table.Header fullWidth>
    <TableHeader
      error={firstErrorMessage(readErrors)}
      isLoading={readStatus === states.PENDING}
      numberOfColumns={columns.length}
    >
      {children}
    </TableHeader>
    {showColumns && (
      <UserGroupsTableColumns
        category={category}
        columns={columns}
        items={items}
        onCheckBoxClick={onCheckBoxClick}
      />
    )}
  </Table.Header>
);

export default UserGroupsTableHeader;
